import { ThemeProvider as Provider } from 'styled-components';
import theme from './theme';
import GlobalStyle from './GlobalStyle';

const ThemeProvider = ({ children }) => (
  <Provider theme={theme}>
    <GlobalStyle />
    {children}
  </Provider>
);

export default ThemeProvider;
